import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import {
   TimeRelativeDefaultValueConfig_FragmentFragmentDoc,
   DateRelativeDefaultValueConfig_FragmentFragmentDoc
} from './template.generatedTypes'
export type IntegerField_FragmentFragment = {
   __typename?: 'IntegerField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   intDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'IntegerRangeConfig'
      intMinValue?: number | null
      intMaxValue?: number | null
   } | null
}

export type FloatField_FragmentFragment = {
   __typename?: 'FloatField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   floatDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'FloatRangeConfig'
      floatMinValue?: number | null
      floatMaxValue?: number | null
   } | null
}

export type EmailField_FragmentFragment = {
   __typename?: 'EmailField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type FileUploaderField_FragmentFragment = {
   __typename?: 'FileUploaderField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   allowedFormats: Array<string>
   maxNumberOfFilesToUpload: number
   eachFileMaxSizeInKb: number
   canDownload: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type LongTextField_FragmentFragment = {
   __typename?: 'LongTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type PlainTextField_FragmentFragment = {
   __typename?: 'PlainTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   isUnique: boolean
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type ShortTextField_FragmentFragment = {
   __typename?: 'ShortTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
   prefixOptions?: {
      __typename?: 'PrefixOptions'
      isEnabled: boolean
      values: Array<string>
      optionsValueType: Types.OptionsValueType
      conditionalPrefixOptions: Array<{
         __typename?: 'ConditionalFieldOptions'
         parentFieldId: string
         options: Array<{
            __typename?: 'ConditionalOptions'
            options: Array<string>
            parentFieldOption: string
         }>
      }>
   } | null
   suffixOptions?: {
      __typename?: 'SuffixOptions'
      isEnabled: boolean
      values: Array<string>
   } | null
}

export type UrlField_FragmentFragment = {
   __typename?: 'URLField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   alternateDisplayText?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type TimeField_FragmentFragment = {
   __typename?: 'TimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   timeFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'TimeRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfSeconds: number
      TimeValueEnum: Types.TimeValueEnum
   } | null
}

export type DateField_FragmentFragment = {
   __typename?: 'DateField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfDays: number
      DateValueEnum: Types.DateValueEnum
   } | null
}

export type DateTimeField_FragmentFragment = {
   __typename?: 'DateTimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateTimeDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateTimeRelativeDefaultValueConfig'
      dateConfig?: {
         __typename?: 'DateRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfDays: number
         DateValueEnum: Types.DateValueEnum
      } | null
      timeConfig?: {
         __typename?: 'TimeRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfSeconds: number
         TimeValueEnum: Types.TimeValueEnum
      } | null
   } | null
}

export type DropdownField_FragmentFragment = {
   __typename?: 'DropdownField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isLabelsEnabled: boolean
   iconId?: string | null
   dropdownFieldUiStyle: Types.DropdownFieldUiStyleEnum
   allowOtherOptions: boolean
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
}

export type MultiSelectField_FragmentFragment = {
   __typename?: 'MultiSelectField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isLabelsEnabled: boolean
   iconId?: string | null
   multiSelectFieldUiStyle: Types.MultiSelectFieldUiStyleEnum
   allowOtherOptions: boolean
   tags: Array<Types.FieldTag>
   multiStringDefaultValue: Array<string>
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
}

export type CheckboxGroupField_FragmentFragment = {
   __typename?: 'CheckboxGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
   multiStringDefaultValue: Array<string>
}

export type RadioGroupField_FragmentFragment = {
   __typename?: 'RadioGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type PhoneNumberField_FragmentFragment = {
   __typename?: 'PhoneNumberField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type FieldsSelectorField_FragmentFragment = {
   __typename?: 'FieldsSelectorField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   systemFieldEnum?: Types.SystemFieldEnum | null
   iconId?: string | null
   fieldsSelectorFieldUiStyle: Types.FieldSelectorFieldUiStyleEnum
   tags: Array<Types.FieldTag>
   fieldSelectorFieldDefaultValue?: string | null
   dependentFields: Array<{
      __typename?: 'DependentFields'
      option: string
      dependentFieldIds: Array<string>
   }>
}

export type RelationField_FragmentFragment = {
   __typename?: 'RelationField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   iconId?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   linkedSourceFieldId?: string | null
   valueType: Types.RelationFieldValueType
   tags: Array<Types.FieldTag>
   parentFieldOptions?: {
      __typename?: 'ParentFieldOptions'
      options: Array<string>
      parentFieldId: string
   } | null
   relation: {
      __typename?: 'RelationOverviewDetails'
      relationId: string
      name: string
      cardinality: Types.Cardinality
      fromSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
      }
      toSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
      }
   }
   secondDegreeRelation?: {
      __typename?: 'RelationOverviewDetails'
      relationId: string
      name: string
      cardinality: Types.Cardinality
      fromSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
      }
      toSalesTemplateConfig: {
         __typename?: 'RelatedSalesTemplateOverviewDetails'
         salesTemplateId: string
         salesTemplateType: Types.SupportedSalesTemplateTypesForRelation
         displayName: string
         pipelineItemType?: Types.PipelineItemType | null
         salesTemplateName: string
      }
   } | null
}

export type GeoLocationField_FragmentFragment = {
   __typename?: 'GeoLocationField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type GeoShapeField_FragmentFragment = {
   __typename?: 'GeoShapeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   variantType: Types.GeoShapeVariantType
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type FieldNotFound_FragmentFragment = {
   __typename?: 'FieldNotFound'
   message?: string | null
   fieldId: string
}

export type NotPermittedField_FragmentFragment = {
   __typename?: 'NotPermittedField'
   message?: string | null
   fieldId: string
}

export type FieldIsDeleted_FragmentFragment = {
   __typename?: 'FieldIsDeleted'
   message?: string | null
   fieldId: string
}

export type Sales_Crm_Web_Field_CheckboxGroupField_Fragment = {
   __typename?: 'CheckboxGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
   multiStringDefaultValue: Array<string>
}

export type Sales_Crm_Web_Field_DateField_Fragment = {
   __typename?: 'DateField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfDays: number
      DateValueEnum: Types.DateValueEnum
   } | null
}

export type Sales_Crm_Web_Field_DateTimeField_Fragment = {
   __typename?: 'DateTimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   dateTimeDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'DateTimeRelativeDefaultValueConfig'
      dateConfig?: {
         __typename?: 'DateRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfDays: number
         DateValueEnum: Types.DateValueEnum
      } | null
      timeConfig?: {
         __typename?: 'TimeRelativeDefaultValueConfig'
         operator: Types.ArithmeticOperation
         noOfSeconds: number
         TimeValueEnum: Types.TimeValueEnum
      } | null
   } | null
}

export type Sales_Crm_Web_Field_DropdownField_Fragment = {
   __typename?: 'DropdownField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isLabelsEnabled: boolean
   iconId?: string | null
   dropdownFieldUiStyle: Types.DropdownFieldUiStyleEnum
   allowOtherOptions: boolean
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
}

export type Sales_Crm_Web_Field_EmailField_Fragment = {
   __typename?: 'EmailField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Field_FieldsSelectorField_Fragment = {
   __typename?: 'FieldsSelectorField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   systemFieldEnum?: Types.SystemFieldEnum | null
   iconId?: string | null
   fieldsSelectorFieldUiStyle: Types.FieldSelectorFieldUiStyleEnum
   tags: Array<Types.FieldTag>
   fieldSelectorFieldDefaultValue?: string | null
   dependentFields: Array<{
      __typename?: 'DependentFields'
      option: string
      dependentFieldIds: Array<string>
   }>
}

export type Sales_Crm_Web_Field_FileUploaderField_Fragment = {
   __typename?: 'FileUploaderField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   allowedFormats: Array<string>
   maxNumberOfFilesToUpload: number
   eachFileMaxSizeInKb: number
   canDownload: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Field_FloatField_Fragment = {
   __typename?: 'FloatField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   floatDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'FloatRangeConfig'
      floatMinValue?: number | null
      floatMaxValue?: number | null
   } | null
}

export type Sales_Crm_Web_Field_GeoLocationField_Fragment = {
   __typename?: 'GeoLocationField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type Sales_Crm_Web_Field_GeoShapeField_Fragment = {
   __typename?: 'GeoShapeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   variantType: Types.GeoShapeVariantType
   addressFieldIds: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type Sales_Crm_Web_Field_IntegerField_Fragment = {
   __typename?: 'IntegerField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   intDefaultValue?: number | null
   rangeConfig?: {
      __typename?: 'IntegerRangeConfig'
      intMinValue?: number | null
      intMaxValue?: number | null
   } | null
}

export type Sales_Crm_Web_Field_LongTextField_Fragment = {
   __typename?: 'LongTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Field_MultiSelectField_Fragment = {
   __typename?: 'MultiSelectField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   isLabelsEnabled: boolean
   iconId?: string | null
   multiSelectFieldUiStyle: Types.MultiSelectFieldUiStyleEnum
   allowOtherOptions: boolean
   tags: Array<Types.FieldTag>
   multiStringDefaultValue: Array<string>
   optionColors: Array<{
      __typename?: 'OptionColorConfig'
      option: string
      color: Types.ColorEnum
   }>
}

export type Sales_Crm_Web_Field_PhoneNumberField_Fragment = {
   __typename?: 'PhoneNumberField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   isUnique: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
}

export type Sales_Crm_Web_Field_PlainTextField_Fragment = {
   __typename?: 'PlainTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   isUnique: boolean
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Field_RadioGroupField_Fragment = {
   __typename?: 'RadioGroupField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   options: Array<string>
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_Field_RelationField_Fragment = {
   __typename?: 'RelationField'
}

export type Sales_Crm_Web_Field_ShortTextField_Fragment = {
   __typename?: 'ShortTextField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   systemFieldEnum?: Types.SystemFieldEnum | null
   isFormulaEnabled: boolean
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
   prefixOptions?: {
      __typename?: 'PrefixOptions'
      isEnabled: boolean
      values: Array<string>
      optionsValueType: Types.OptionsValueType
      conditionalPrefixOptions: Array<{
         __typename?: 'ConditionalFieldOptions'
         parentFieldId: string
         options: Array<{
            __typename?: 'ConditionalOptions'
            options: Array<string>
            parentFieldOption: string
         }>
      }>
   } | null
   suffixOptions?: {
      __typename?: 'SuffixOptions'
      isEnabled: boolean
      values: Array<string>
   } | null
}

export type Sales_Crm_Web_Field_TimeField_Fragment = {
   __typename?: 'TimeField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   timeFieldDefaultValue?: string | null
   relativeDefaultValueConfig?: {
      __typename?: 'TimeRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfSeconds: number
      TimeValueEnum: Types.TimeValueEnum
   } | null
}

export type Sales_Crm_Web_Field_UrlField_Fragment = {
   __typename?: 'URLField'
   fieldId: string
   permissionType: Types.PermissionType
   gofId: string
   salesTemplateId: string
   name: string
   description?: string | null
   fieldType?: Types.FieldType | null
   isRequired: boolean
   helpText?: string | null
   tooltip?: string | null
   placeholderText?: string | null
   regexErrorMessage?: string | null
   validationRegex?: string | null
   isUnique: boolean
   alternateDisplayText?: string | null
   iconId?: string | null
   tags: Array<Types.FieldTag>
   stringDefaultValue?: string | null
}

export type Sales_Crm_Web_FieldFragment =
   | Sales_Crm_Web_Field_CheckboxGroupField_Fragment
   | Sales_Crm_Web_Field_DateField_Fragment
   | Sales_Crm_Web_Field_DateTimeField_Fragment
   | Sales_Crm_Web_Field_DropdownField_Fragment
   | Sales_Crm_Web_Field_EmailField_Fragment
   | Sales_Crm_Web_Field_FieldsSelectorField_Fragment
   | Sales_Crm_Web_Field_FileUploaderField_Fragment
   | Sales_Crm_Web_Field_FloatField_Fragment
   | Sales_Crm_Web_Field_GeoLocationField_Fragment
   | Sales_Crm_Web_Field_GeoShapeField_Fragment
   | Sales_Crm_Web_Field_IntegerField_Fragment
   | Sales_Crm_Web_Field_LongTextField_Fragment
   | Sales_Crm_Web_Field_MultiSelectField_Fragment
   | Sales_Crm_Web_Field_PhoneNumberField_Fragment
   | Sales_Crm_Web_Field_PlainTextField_Fragment
   | Sales_Crm_Web_Field_RadioGroupField_Fragment
   | Sales_Crm_Web_Field_RelationField_Fragment
   | Sales_Crm_Web_Field_ShortTextField_Fragment
   | Sales_Crm_Web_Field_TimeField_Fragment
   | Sales_Crm_Web_Field_UrlField_Fragment

export type AssigneeFieldMapping_FragmentFragment = {
   __typename?: 'AssigneeFieldMapping'
   assigneeFieldId: string
   assignedOnFieldId: string
}

export const RelationField_FragmentFragmentDoc = gql`
   fragment RelationField_Fragment on RelationField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      iconId
      systemFieldEnum
      parentFieldOptions {
         options
         parentFieldId
      }
      linkedSourceFieldId
      relation {
         relationId
         name
         cardinality
         fromSalesTemplateConfig {
            salesTemplateId
            displayName
            pipelineItemType
            salesTemplateName
            salesTemplateType
         }
         toSalesTemplateConfig {
            salesTemplateId
            salesTemplateType
            displayName
            pipelineItemType
            salesTemplateName
         }
      }
      secondDegreeRelation {
         relationId
         name
         cardinality
         fromSalesTemplateConfig {
            salesTemplateId
            displayName
            pipelineItemType
            salesTemplateName
            salesTemplateType
         }
         toSalesTemplateConfig {
            salesTemplateId
            salesTemplateType
            displayName
            pipelineItemType
            salesTemplateName
         }
      }
      valueType
      tags
   }
`
export const FieldNotFound_FragmentFragmentDoc = gql`
   fragment FieldNotFound_Fragment on FieldNotFound {
      message
      fieldId
   }
`
export const NotPermittedField_FragmentFragmentDoc = gql`
   fragment NotPermittedField_Fragment on NotPermittedField {
      message
      fieldId
   }
`
export const FieldIsDeleted_FragmentFragmentDoc = gql`
   fragment FieldIsDeleted_Fragment on FieldIsDeleted {
      message
      fieldId
   }
`
export const IntegerField_FragmentFragmentDoc = gql`
   fragment IntegerField_Fragment on IntegerField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      rangeConfig {
         intMinValue: minValue
         intMaxValue: maxValue
      }
      intDefaultValue: defaultValue
      isUnique
      isFormulaEnabled
      iconId
      tags
   }
`
export const FloatField_FragmentFragmentDoc = gql`
   fragment FloatField_Fragment on FloatField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      rangeConfig {
         floatMinValue: minValue
         floatMaxValue: maxValue
      }
      floatDefaultValue: defaultValue
      isUnique
      isFormulaEnabled
      iconId
      tags
   }
`
export const EmailField_FragmentFragmentDoc = gql`
   fragment EmailField_Fragment on EmailField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      regexErrorMessage
      validationRegex
      isUnique
      stringDefaultValue: defaultValue
      iconId
      tags
   }
`
export const FileUploaderField_FragmentFragmentDoc = gql`
   fragment FileUploaderField_Fragment on FileUploaderField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      allowedFormats
      stringDefaultValue: defaultValue
      maxNumberOfFilesToUpload
      eachFileMaxSizeInKb
      canDownload
      iconId
      tags
   }
`
export const LongTextField_FragmentFragmentDoc = gql`
   fragment LongTextField_Fragment on LongTextField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      stringDefaultValue: defaultValue
      isFormulaEnabled
      iconId
      tags
   }
`
export const PlainTextField_FragmentFragmentDoc = gql`
   fragment PlainTextField_Fragment on PlainTextField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      regexErrorMessage
      validationRegex
      systemFieldEnum
      isUnique
      stringDefaultValue: defaultValue
      isFormulaEnabled
      iconId
      tags
   }
`
export const ShortTextField_FragmentFragmentDoc = gql`
   fragment ShortTextField_Fragment on ShortTextField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      regexErrorMessage
      validationRegex
      systemFieldEnum
      stringDefaultValue: defaultValue
      prefixOptions {
         isEnabled
         values
         optionsValueType
         conditionalPrefixOptions {
            parentFieldId
            options {
               options
               parentFieldOption
            }
         }
      }
      suffixOptions {
         isEnabled
         values
      }
      isFormulaEnabled
      iconId
      tags
   }
`
export const UrlField_FragmentFragmentDoc = gql`
   fragment URLField_Fragment on URLField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      regexErrorMessage
      validationRegex
      isUnique
      alternateDisplayText
      stringDefaultValue: defaultValue
      iconId
      tags
   }
`
export const TimeField_FragmentFragmentDoc = gql`
   fragment TimeField_Fragment on TimeField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      timeFieldDefaultValue: defaultValue
      relativeDefaultValueConfig {
         ...TimeRelativeDefaultValueConfig_Fragment
      }
      iconId
      tags
   }
   ${TimeRelativeDefaultValueConfig_FragmentFragmentDoc}
`
export const DateField_FragmentFragmentDoc = gql`
   fragment DateField_Fragment on DateField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      dateFieldDefaultValue: defaultValue
      relativeDefaultValueConfig {
         ...DateRelativeDefaultValueConfig_Fragment
      }
      iconId
      tags
   }
   ${DateRelativeDefaultValueConfig_FragmentFragmentDoc}
`
export const DateTimeField_FragmentFragmentDoc = gql`
   fragment DateTimeField_Fragment on DateTimeField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      relativeDefaultValueConfig {
         dateConfig {
            ...DateRelativeDefaultValueConfig_Fragment
         }
         timeConfig {
            ...TimeRelativeDefaultValueConfig_Fragment
         }
      }
      dateTimeDefaultValue: defaultValue
      iconId
      tags
   }
   ${DateRelativeDefaultValueConfig_FragmentFragmentDoc}
   ${TimeRelativeDefaultValueConfig_FragmentFragmentDoc}
`
export const DropdownField_FragmentFragmentDoc = gql`
   fragment DropdownField_Fragment on DropdownField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      options
      stringDefaultValue: defaultValue
      isLabelsEnabled
      optionColors {
         option
         color
      }
      iconId
      dropdownFieldUiStyle
      allowOtherOptions
      tags
   }
`
export const MultiSelectField_FragmentFragmentDoc = gql`
   fragment MultiSelectField_Fragment on MultiSelectField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      options
      multiStringDefaultValue: defaultValues
      isLabelsEnabled
      optionColors {
         option
         color
      }
      iconId
      multiSelectFieldUiStyle
      allowOtherOptions
      tags
   }
`
export const CheckboxGroupField_FragmentFragmentDoc = gql`
   fragment CheckboxGroupField_Fragment on CheckboxGroupField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      options
      multiStringDefaultValue: defaultValues
      iconId
      tags
   }
`
export const RadioGroupField_FragmentFragmentDoc = gql`
   fragment RadioGroupField_Fragment on RadioGroupField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      options
      stringDefaultValue: defaultValue
      iconId
      tags
   }
`
export const PhoneNumberField_FragmentFragmentDoc = gql`
   fragment PhoneNumberField_Fragment on PhoneNumberField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      isUnique
      iconId
      tags
   }
`
export const FieldsSelectorField_FragmentFragmentDoc = gql`
   fragment FieldsSelectorField_Fragment on FieldsSelectorField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      options
      fieldSelectorFieldDefaultValue: defaultValue
      dependentFields {
         option
         dependentFieldIds
      }
      systemFieldEnum
      salesTemplateId
      iconId
      fieldsSelectorFieldUiStyle
      tags
   }
`
export const GeoLocationField_FragmentFragmentDoc = gql`
   fragment GeoLocationField_Fragment on GeoLocationField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      systemFieldEnum
      addressFieldIds
      iconId
      tags
   }
`
export const GeoShapeField_FragmentFragmentDoc = gql`
   fragment GeoShapeField_Fragment on GeoShapeField {
      fieldId
      permissionType
      gofId
      salesTemplateId
      name
      description
      fieldType
      isRequired
      helpText
      tooltip
      placeholderText
      systemFieldEnum
      variantType
      addressFieldIds
      iconId
      tags
   }
`
export const Sales_Crm_Web_FieldFragmentDoc = gql`
   fragment Sales_Crm_Web_Field on Field {
      ... on IntegerField {
         ...IntegerField_Fragment
      }
      ... on FloatField {
         ...FloatField_Fragment
      }
      ... on EmailField {
         ...EmailField_Fragment
      }
      ... on FileUploaderField {
         ...FileUploaderField_Fragment
      }
      ... on LongTextField {
         ...LongTextField_Fragment
      }
      ... on PlainTextField {
         ...PlainTextField_Fragment
      }
      ... on ShortTextField {
         ...ShortTextField_Fragment
      }
      ... on URLField {
         ...URLField_Fragment
      }
      ... on TimeField {
         ...TimeField_Fragment
      }
      ... on DateField {
         ...DateField_Fragment
      }
      ... on DateTimeField {
         ...DateTimeField_Fragment
      }
      ... on DropdownField {
         ...DropdownField_Fragment
      }
      ... on MultiSelectField {
         ...MultiSelectField_Fragment
      }
      ... on CheckboxGroupField {
         ...CheckboxGroupField_Fragment
      }
      ... on RadioGroupField {
         ...RadioGroupField_Fragment
      }
      ... on PhoneNumberField {
         ...PhoneNumberField_Fragment
      }
      ... on FieldsSelectorField {
         ...FieldsSelectorField_Fragment
      }
      ... on GeoLocationField {
         ...GeoLocationField_Fragment
      }
      ... on GeoShapeField {
         ...GeoShapeField_Fragment
      }
   }
   ${IntegerField_FragmentFragmentDoc}
   ${FloatField_FragmentFragmentDoc}
   ${EmailField_FragmentFragmentDoc}
   ${FileUploaderField_FragmentFragmentDoc}
   ${LongTextField_FragmentFragmentDoc}
   ${PlainTextField_FragmentFragmentDoc}
   ${ShortTextField_FragmentFragmentDoc}
   ${UrlField_FragmentFragmentDoc}
   ${TimeField_FragmentFragmentDoc}
   ${DateField_FragmentFragmentDoc}
   ${DateTimeField_FragmentFragmentDoc}
   ${DropdownField_FragmentFragmentDoc}
   ${MultiSelectField_FragmentFragmentDoc}
   ${CheckboxGroupField_FragmentFragmentDoc}
   ${RadioGroupField_FragmentFragmentDoc}
   ${PhoneNumberField_FragmentFragmentDoc}
   ${FieldsSelectorField_FragmentFragmentDoc}
   ${GeoLocationField_FragmentFragmentDoc}
   ${GeoShapeField_FragmentFragmentDoc}
`
export const AssigneeFieldMapping_FragmentFragmentDoc = gql`
   fragment AssigneeFieldMapping_Fragment on AssigneeFieldMapping {
      assigneeFieldId
      assignedOnFieldId
   }
`
